import * as React from "react";

export const IconContentCopy = (props: React.SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_38244_35759)">
      <path d="M13.3334 0.833008L3.33341 0.833008C2.41675 0.833008 1.66675 1.58301 1.66675 2.49967L1.66675 14.1663H3.33341L3.33341 2.49967L13.3334 2.49967V0.833008ZM15.8334 4.16634L6.66675 4.16634C5.75008 4.16634 5.00008 4.91634 5.00008 5.83301L5.00008 17.4997C5.00008 18.4163 5.75008 19.1663 6.66675 19.1663L15.8334 19.1663C16.7501 19.1663 17.5001 18.4163 17.5001 17.4997L17.5001 5.83301C17.5001 4.91634 16.7501 4.16634 15.8334 4.16634ZM15.8334 17.4997L6.66675 17.4997L6.66675 5.83301L15.8334 5.83301L15.8334 17.4997Z" fill="currentColor"/>
    </g>
    <defs>
      <clipPath id="clip0_38244_35759">
        <rect width="20" height="20" fill="white"/>
      </clipPath>
    </defs>
  </svg>
);
